import {ROOT_URL} from '../../config';
import request, {uploadImages} from '../../components/api/api';
import {toastr} from 'react-redux-toastr';
import {push} from 'react-router-redux';
import {
    fetchedBlock,
    updatedBlock,
    deletedBlock,
    fetchedBlockTypes,
    fetchedBlockRevisions,
    fetchedBlockTranslations,
    updatedBlockTranslation,
    fetchedBlockSiteTranslation,
    enabledBlock,
    disabledBlock,
    disabledTranslation,
    enabledTranslation,
    deletedBlockTranslation,
    deletedBlockRevision,
    fetchingBlocks,
    fetchedTranslationRevisions,
    activatedBlockRevision,
    activatedTranslationRevision,
} from './actions';

export function fetchBlock(id) {
    return (dispatch) => {
        dispatch(fetchingBlocks());
        let options = {
            url: `${ROOT_URL}/blocks/${id}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedBlock(response.data))
        );
    };
}

export function createBlock(block) {
    return (dispatch) => {
        let images = [];

        if (block && block.images) {
            block.images.forEach((image, index) => {
                if (image.new && !image.deleted) {
                    images[index] = {
                        index,
                        image,
                        code: null,
                    };
                }
            });
        }

        uploadImages(
            dispatch,
            images,
            'block',
            block.site_id,
            (response) => {
                let codes = null;

                if (response.data && response.data.images_codes) {
                    if (response.data.images_codes.length) {
                        codes = response.data.images_codes;
                    }
                }

                let options = {
                    url: `${ROOT_URL}/blocks`,
                    method: 'POST',
                    data: {
                        id: block.id,
                        block_type_id: block.block_type_id,
                        destination_id: block.destination_id,
                        trip_format_id: block.trip_format_id,
                        type_of_work_id: block.type_of_work_id,
                        title: block.title,
                        body: block.body,
                        name: block.display_name,
                        button_text: block.button_text,
                        page: block.page,
                        site_id: block.site_id,
                        images: block.images,
                        codes,
                        imageSettings: block.imageSettings || [],
                        videos: block.videos,
                        videoSettings: block.videoSettings || [],
                    },
                };
                return request(options, dispatch)
                    .then(() =>
                        toastr.success(
                            'Success!',
                            'The block has been created.'
                        )
                    )
                    .then(() => dispatch(push(`/blocks`)));
            },
            (err) => {
                console.log(err);
            }
        );
    };
}

export function updateBlock(block) {
    return (dispatch) => {
        let images = [];

        if (block && block.images) {
            block.images.forEach((image, index) => {
                if (image.new && !image.deleted) {
                    images[index] = {
                        index,
                        image,
                        code: null,
                    };
                }
            });
        }

        uploadImages(
            dispatch,
            images,
            'block',
            block.site_id,
            (response) => {
                let codes = null;

                if (response.data && response.data.images_codes) {
                    if (response.data.images_codes.length) {
                        codes = response.data.images_codes;
                    }
                }

                let options = {
                    url: `${ROOT_URL}/blocks/${block.id}`,
                    method: 'PUT',
                    data: {
                        id: block.id,
                        block_type_id: block.block_type_id,
                        destination_id: block.destination_id,
                        trip_format_id: block.trip_format_id,
                        type_of_work_id: block.type_of_work_id,
                        title: block.title,
                        body: block.body,
                        button_text: block.button_text,
                        page: {
                            id: block.page.id,
                            title: block.page.title,
                        },
                        name: block.display_name,
                        site_id: block.site_id,
                        images: block.images,
                        codes,
                        imageSettings: block.imageSettings || [],
                        videos: block.videos,
                        videoSettings: block.videoSettings || [],
                    },
                };
                return request(options, dispatch)
                    .then(() => dispatch(updatedBlock(block)))
                    .then(() => dispatch(fetchBlock(block.id)))
                    .then(() =>
                        toastr.success(
                            'Success!',
                            'Block "' +
                                block.display_name +
                                '" has been updated.'
                        )
                    );
            },
            (err) => {
                console.log(err);
            }
        );
    };
}

export function deleteBlock(block) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${block}`,
            method: 'DELETE',
        };
        return request(options, dispatch)
            .then((response) => dispatch(deletedBlock(block)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Block ' + block + ' has been deleted.'
                )
            );
    };
}

export function fetchBlockTypes() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/block/types`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedBlockTypes(response.data))
        );
    };
}

export function fetchBlockTranslations(blockId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${blockId}/translations`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedBlockTranslations(response.data))
        );
    };
}

export function createBlockTranslation(blockId, siteId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${blockId}/translations`,
            method: 'POST',
            data: {site_id: siteId},
        };
        return request(options, dispatch)
            .then((response) =>
                dispatch(fetchBlockSiteTranslation(blockId, siteId))
            )
            .then(() =>
                toastr.success(
                    'Success!',
                    'A new translation has been created. Please add translation text below.'
                )
            );
    };
}

export function fetchBlockSiteTranslation(blockId, siteId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${blockId}/translations/${siteId}`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedBlockSiteTranslation(response.data))
        );
    };
}

export function updateBlockTranslation(blockTranslation) {
    return (dispatch) => {
        const {
            block_id,
            id,
            display_name,
            title,
            body,
            button_text,
            pagePicker,
        } = blockTranslation;
        const name = display_name;
        const page = pagePicker.page;

        let options = {
            url: `${ROOT_URL}/blocks/${block_id}/translations/${id}`,
            method: 'PUT',
            data: {
                name,
                title,
                body,
                button_text,
                page,
            },
        };
        return request(options, dispatch)
            .then((response) =>
                dispatch(updatedBlockTranslation(blockTranslation))
            )
            .then(() =>
                toastr.success(
                    'Success!',
                    'Translation for block "' +
                        blockTranslation.display_name +
                        '" has been updated.'
                )
            );
    };
}

export function disableBlock(blockId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${blockId}/disable`,
            method: 'PUT',
        };
        return request(options, dispatch)
            .then((response) => dispatch(disabledBlock(blockId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Block ' + blockId + ' has been disabled.'
                )
            );
    };
}

export function enableBlock(blockId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${blockId}/enable`,
            method: 'PUT',
        };
        return request(options, dispatch)
            .then((response) => dispatch(enabledBlock(blockId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Block ' + blockId + ' has been enabled.'
                )
            );
    };
}

export function deleteBlockTranslation(translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/translations/${translationId}`,
            method: 'DELETE',
        };
        return request(options, dispatch)
            .then((response) =>
                dispatch(deletedBlockTranslation(translationId))
            )
            .then(() =>
                toastr.success(
                    'Success!',
                    'Translation ' + translationId + ' has been deleted.'
                )
            );
    };
}

export function disableTranslation(translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/translations/${translationId}/disable`,
            method: 'PUT',
            data: {},
        };
        return request(options, dispatch)
            .then((response) => dispatch(disabledTranslation(translationId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Translation ' + translationId + ' has been disabled.'
                )
            );
    };
}

export function enableTranslation(translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/translations/${translationId}/enable`,
            method: 'PUT',
            data: {},
        };
        return request(options, dispatch)
            .then((response) => dispatch(enabledTranslation(translationId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Translation ' + translationId + ' has been enabled.'
                )
            );
    };
}

export function fetchBlockRevisions(blockId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${blockId}/revisions`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedBlockRevisions(response.data))
        );
    };
}

export function deleteBlockRevision(revisionId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/revisions/${revisionId}`,
            method: 'DELETE',
        };
        return request(options, dispatch)
            .then((response) => dispatch(deletedBlockRevision(revisionId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Revision ' + revisionId + ' has been deleted.'
                )
            );
    };
}

export function activeBlockRevision(blockId, revisionId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/${blockId}/revisions/active`,
            method: 'PUT',
            data: {
                revision: revisionId,
            },
        };
        return request(options, dispatch)
            .then((response) => dispatch(activatedBlockRevision(revisionId)))
            .then(() =>
                toastr.success(
                    'Success!',
                    'Revision for block ' + blockId + ' has been approved.'
                )
            );
    };
}

export function fetchTranslationRevisions(translationId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/translations/${translationId}/revisions`,
            method: 'GET',
        };
        return request(options, dispatch).then((response) =>
            dispatch(fetchedTranslationRevisions(response.data))
        );
    };
}

export function activeTranslationRevision(translationId, revisionId) {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/blocks/translations/${translationId}/active`,
            method: 'PUT',
            data: {
                revision: revisionId,
            },
        };
        return request(options, dispatch)
            .then((response) =>
                dispatch(activatedTranslationRevision(revisionId))
            )
            .then(() =>
                toastr.success(
                    'Success!',
                    'Revision for translation ' +
                        translationId +
                        ' has been approved.'
                )
            );
    };
}



// WEBPACK FOOTER //
// ./src/containers/blocks/thunks.js